var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolunteers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.38 12.5C13.52 5.453 7.633 0 .5 0v12.5z",
    fill: "#60B6B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.378 0h12.5v12.5h-12.5zM14.442 25H.5l6.971-12.5z",
    fill: "#335280"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.69,
    cy: 18.75,
    fill: "#60B6B1",
    r: 6.25
  })));
}
export default SvgVolunteers;